import * as yup from "yup";

import { FormId } from "../../../../components/enums";
import { radioValidator } from "../../../../utilities/validators";
import { trimmedString } from "../../../../utilities/validators/trimmedString";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.PERPETRATOR_GENERAL]: yup.object({
    [ComponentId.PERPETRATOR_GENERAL_WAS_DRIVER_PERPETRATOR]: radioValidator,
    [ComponentId.PERPETRATOR_GENERAL_WAS_DRIVER_SOBER]: trimmedString.onlyIfFieldIsVisible(
      radioValidator
    ),
    [ComponentId.PERPETRATOR_GENERAL_IS_KNOWN]: trimmedString.onlyIfFieldIsVisible(
      radioValidator
    ),
    [ComponentId.PERPETRATOR_GENERAL_WAS_DRIVING]: trimmedString.onlyIfFieldIsVisible(
      radioValidator
    ),
    [ComponentId.PERPETRATOR_GENERAL_ID]: trimmedString.onlyIfFieldIsVisible(
      radioValidator
    ),
    [ComponentId.PERPETRATOR_GENERAL_CAR_OWNER]: trimmedString.onlyIfFieldIsVisible(
      radioValidator
    ),
  }),
};
